import { render, staticRenderFns } from "./APIQuestionnaire.vue?vue&type=template&id=3a89fbea&scoped=true"
import script from "./APIQuestionnaire.vue?vue&type=script&lang=js"
export * from "./APIQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89fbea",
  null
  
)

export default component.exports